import { render, staticRenderFns } from "./cate.vue?vue&type=template&id=bcb9d60c&scoped=true&"
import script from "./cate.vue?vue&type=script&lang=js&"
export * from "./cate.vue?vue&type=script&lang=js&"
import style0 from "./cate.vue?vue&type=style&index=0&id=bcb9d60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb9d60c",
  null
  
)

export default component.exports